// src/components/store/sections/faqs/FaqV5TwocolumnboxRoyalViolet.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV5TwocolumnboxRoyalViolet(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={5}
      archKey="two_column_box"
      archLabel="Two-Column Split Grid"
      palName="RoyalViolet"
      grad="from-violet-600 via-purple-600 to-indigo-700"
      lightBg="bg-violet-50"
      textCol="text-violet-700"
      borderCol="border-violet-200"
      btnCls="bg-violet-600 hover:bg-violet-700"
      hexCol="#8b5cf6"
      {...props}
    />
  );
}
